import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import * as Scroll from "react-scroll";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import {
  Switch,
  Route,
  useParams,
  Redirect,
  useRouteMatch,
} from "react-router-dom";
import { Banner, CardSubMenu, Gap } from "../../components";
import Context from "../../context";
import { Skeleton } from "@material-ui/lab";

const scroll = Scroll.animateScroll;

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  margin: 0 16px;
  padding-bottom: 32px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

const StyledBorder = styled.div`
  border-left: 1px solid #d4d4d4;
  margin: 0 40px;
  @media screen and (max-width: 800px) {
    margin-left: 16px;
    margin-right: 32px;
  }
  @media screen and (max-width: 500px) {
    display: none;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 650px;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const DetailFasilitas = ({ data, isId }: any) => {
  const { fasilitasId }: any = useParams();

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const selectedData = data.find((row: any) => row.title_id.includes(fasilitasId));


  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        style={{ marginBottom: "2rem" }}
        gutterBottom
      >
        {isId ? selectedData.title_id : selectedData.title_en}
      </Typography>
      <img
        style={{ width: "100%" }}
        src={`${process.env.REACT_APP_URL}/images/${selectedData.image}`}
        alt={isId ? selectedData.title_id : selectedData.title_en}
      />

      <div id="content" style={{ marginTop: "1rem" }}>
        {parse(isId ? selectedData.content_id : selectedData.content_en)}
      </div>
    </>
  );
};

const Fasilitas = () => {
  const context = React.useContext(Context);
  const { path, url } = useRouteMatch();
  const currentLang = context.getLang();
  const [fasilitasState, setFasilitasState] = useState<any>([]);
  const [loadingState, setLoadingState] = useState(true);
  const isId = currentLang === "ID" ? true : false;

  const getDataVehicle = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=2`
    );
    const resJson = await res.json();
    const checkType = fasilitasState.some((row: any) => row.id_type === 2);
    if (!checkType) {
      setFasilitasState((prevState: any) => [
        ...prevState,
        ...resJson.data.rows,
      ]);
    }
  };

  const getDataSensor = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=12`
    );
    const resJson = await res.json();
    const checkType = fasilitasState.some((row: any) => row.id_type === 12);
    if (!checkType) {
      setFasilitasState((prevState: any) => [
        ...prevState,
        ...resJson.data.rows,
      ]);
    }
  };

  const getDataCommandCenter = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=13`
    );
    const resJson = await res.json();
    const checkType = fasilitasState.some((row: any) => row.id_type === 13);
    if (!checkType) {
      setFasilitasState((prevState: any) => [
        ...prevState,
        ...resJson.data.rows,
      ]);
    }
  };

  const loadData = async () => {
    try {
      await getDataVehicle();
      await getDataSensor();
      await getDataCommandCenter();
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Banner
        title={
          isId
            ? "Armada & Perlengkapan Operasi"
            : "Present Vehicle and Equipment"
        }
      />
      <StyledBody>
        <StyledSidebar>
          {loadingState ? (
            <Skeleton variant="rect" height={200} />
          ) : (
            <>
              <CardSubMenu
                title={isId ? "Kendaraan" : "Vehicle"}
                url={url}
                isId={isId}
                data={fasilitasState
                  .filter((row: any) => row.id_type === 2)
                  .map((row: any) => ({
                    title: row.title_id,
                    titleEn: row.title_en,
                    subUrl: `/${row.title_id}`,
                  }))}
              />
              <Gap height={2.28} />
              <CardSubMenu
                title={isId ? "Perlengkapan Operasi" : "Equipment"}
                url={url}
                isId={isId}
                data={fasilitasState
                  .filter((row: any) => row.id_type === 12)
                  .map((row: any) => ({
                    title: row.title_id,
                    titleEn: row.title_en,
                    subUrl: `/${row.title_id}`,
                  }))}
              />
            </>
          )}
          {/* <Card title={isId ? "Berita Terbaru" : "Latest News"}>
            <BeritaTerbaru />
          </Card> */}
        </StyledSidebar>
        <StyledBorder />
        <StyledContent>
          {loadingState ? (
            <>
              <Skeleton
                variant="rect"
                height={42}
                style={{ marginBottom: 16 }}
              />
              <Skeleton variant="rect" height={200} />
            </>
          ) : (
            <Switch>
              <Route exact path={path}>
                <Redirect to={`${path}/${fasilitasState[0].title_id}`} />
              </Route>
              <Route path={`${path}/:fasilitasId`}>
                <DetailFasilitas isId={isId} data={fasilitasState} />
              </Route>
            </Switch>
          )}
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default Fasilitas;
